import { PreviewVariant } from '../../preview-common/preview-variant.interface';
import { RsaGoogleDesktop01PreviewComponent } from './rsa-google-desktop-01/rsa-google-desktop-01.component';
import { RsaGoogleMobile01PreviewComponent } from './rsa-google-mobile-01/rsa-google-mobile-01.component';

export const RSA_VARIANTS: PreviewVariant[] = [
  { id: 'google-desktop-01', platform: 'google', device: 'desktop', label: 'Placement 1', component: RsaGoogleDesktop01PreviewComponent },
  { id: 'google-mobile-01', platform: 'google', device: 'mobile', label: 'Placement 1', component: RsaGoogleMobile01PreviewComponent },
];
